import { feedbackApi } from './apis';
import { AxiosResponse } from 'axios';
import { FeedbackResponseInterface } from '@types';

const ROUTES = {
  getFeedbackData: '/support-data',
};

const cache = new Map<string, AxiosResponse>();

export const getFeedbackData = async (): Promise<FeedbackResponseInterface> => {
  const cacheKey = 'feedbackForm';
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey).data;
  }
  const response = await feedbackApi.get(`${ROUTES.getFeedbackData}`);
  cache.set('feedbackForm', response);
  return response.data;
};
